import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
});

// Intercepteur réponse — logout si 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('ecf_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
